import{jsxs as t,jsx as e}from"react/jsx-runtime";import{createContext as r,useContext as o,useState as i,useMemo as n,useEffect as s}from"react";import a from"tailwind-styled-components";import l from"clsx";import d from"dayjs";import m from"rc-motion";import{X as c}from"lucide-react";const p={duration:5e3,closable:!0},u=r({showToast:()=>{}}),b=()=>o(u),f=a.div`
  fixed
  flex
  flex-col
  overflow-hidden
  p-4
  z-50
`,g=a.div`
  bg-white
  py-4
  px-6
  relative
  rounded
  shadow-md
  shadow-brand-primary/20
  w-72

  dark:bg-gray-700
`,h=a.h5`
  text-sm
  font-bold
  text-gray-700

  dark:text-gray-300
`,x=a.p`
  text-base
  text-gray-500

  dark:text-gray-400
`,v=a.span`
  absolute
  bg-brand-primary
  bottom-0
  h-1
  left-0
  origin-left
  right-0
  rounded-bl
  scale-100
  animate-[timer]
  transition-transform

  dark:bg-brand-primary-light
`,y=a.button`
  absolute
  appearance-none
  border-none
  flex
  items-center
  justify-center
  leading-none
  p-[2px]
  right-1
  text-gray-400
  text-sm
  top-1
`,w=({children:r,position:o="top-right"})=>{const[a,b]=i([]),w=l({"bottom-0 flex-col-reverse":o.includes("bottom"),"left-0":o.includes("left"),"left-1/2 -translate-x-1/2":["bottom","top"].includes(o),"right-0":o.includes("right"),"top-0":o.includes("top")}),k=l({"mb-4":o.includes("top"),"mt-4":o.includes("bottom")}),N=n((()=>({showToast:({title:t,message:e,options:r=p})=>{const o=Math.random().toString(16).substring(2,8),i=d();b([{createdAt:i,id:o,title:t,message:e,options:r,visible:!0},...a])}})),[a]);return s((()=>{const t=setInterval((()=>{const t=d();b(a.map((e=>{const{createdAt:r,options:{duration:o}=p}=e;return{...e,visible:t.diff(r)<o}})))}),500);return()=>clearInterval(t)}),[a]),t(u.Provider,{value:N,children:[r,e(f,{className:w,children:a.map((r=>e(m,{motionName:"toast",visible:r.visible,children:({className:i})=>{return t(g,{className:l(o,i,k),role:"status",children:[r.title&&e(h,{children:r.title}),r.message&&e(x,{children:r.message}),r.options?.closable&&e(y,{onClick:(n=r.id,()=>{const t=a.findIndex((t=>t.id===n)),e=a[t];e.createdAt=d().subtract(e.options?.duration||p.duration,"ms"),e.visible=!1,b([...a.slice(0,t),e,...a.slice(t+1)])}),children:e(c,{size:16})}),e(v,{className:"timer",style:{animationDuration:`${(r.options?.duration||p.duration)+500}ms`}})]});var n}},r.id)))})]})};export{u as Context,w as ToastProvider,b as useToasts};
